import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { gray60Color } from '../../utils/styled-components/color-mixins/color-mixins';
/* Styled ProgressBarMarker */
export var StyledProgressBarMark = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  height: 9px;\n  width: 1px;\n  border-left: 1px solid ", ";\n  top: -2px;\n  left: ", "%;\n"], ["\n  position: absolute;\n  height: 9px;\n  width: 1px;\n  border-left: 1px solid ", ";\n  top: -2px;\n  left: ", "%;\n"])), gray60Color, function (_a) {
    var position = _a.position;
    return position;
});
StyledProgressBarMark.displayName = 'StyledProgressBarMark';
var templateObject_1;
//# sourceMappingURL=ProgressBarMarked.styled.js.map